<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img text-left ml-2 mr-2" style="margin-top: 30px; justify-content: center;">
            <!-- Content Row -->
            <div class="card shadow col-md-6 m-auto p-0">
                <div class="card-header pt-1 pb-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white text-center">
                        <div>
                            Atividades
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark p-2">
                        <div>
                            <div class="text-center">
                                <div style="display: flex;">
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            idInput="searchInput"
                                            inputPlaceHolderSufixo="Digite a atividade aqui"
                                            titleScan="Escanear Atividade"
                                            typeInputMode="numeric"
                                            :enterKey="(e) => searchAtividade(e.target.value)"
                                            @displayScanFunction="searchAtividade"
                                            :errorMessage="this.displayError"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body p-2">
                                <ul class="nav nav-tabs small" id="myTab">
                                    <li class="nav-item small">
                                        <a class="nav-link small" :class="{ active: activeTab === 'tab1' }" href="#" @click.prevent="activeTab = 'tab1'">ATIVIDADES</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link small" :class="{ active: activeTab === 'tab2' }" href="#" @click.prevent="activeTab = 'tab2'">MINHAS ATIVIDADES</a>
                                    </li>
                                </ul>
                                <div class="tab-content mt-3" id="myTabContent">
                                    <div class="tab-pane fade" :class="{ 'show active': activeTab === 'tab1' }" v-show="activeTab === 'tab1'">
                                        <div class="scroll-view">
                                            <table class="table table-hover table-striped table-bordered small">
                                                <thead class="d-none">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>#</th>
                                                        <th>#</th>
                                                    </tr>
                                                </thead>
                                                    
                                                <tbody>
                                                    <tr class="small" v-for="item in atividades" :key="item.idatividade">
                                                        <td class="small p-1">
                                                            <span class="font-weight-bold text-primary small">
                                                                {{ item.detalhes.nome }}
                                                                <br>
                                                                {{ String(item.cliente).length > 30
                                                                    ? String(item.cliente).substring(0, 30) + '...'
                                                                    : String(item.cliente)
                                                                }}
                                                            </span>
                                                            <br>
                                                            <span class="text-secondary">
                                                                {{ dateFormat(item.data_gravacao) }}
                                                            </span>
                                                        </td>
                                                        <td class="small p-1">
                                                            {{ item.idatividade }}
                                                            <br>
                                                            <span class="text-secondary small" v-if="!item.idusuario_atv">
                                                                NÃO ATRIBUÍDA
                                                            </span>
                                                            <span class="font-weight-bold text-primary small" v-if="item.usuario_atividade">
                                                                {{ item.usuario_atividade }}
                                                            </span>
                                                        </td>
                                                        <td class="p-1">
                                                            <em class="fa fa-align-justify mt-3"
                                                            @click="getAtividade(item)"></em>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" :class="{ 'show active': activeTab === 'tab2' }" v-show="activeTab === 'tab2'">
                                        <div class="scroll-view">
                                            <table class="table table-hover table-striped table-bordered small">
                                                <thead class="d-none">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>#</th>
                                                        <th>#</th>
                                                    </tr>
                                                </thead>
                                                    
                                                <tbody>
                                                    <tr class="small" v-for="item in minhasatividades" :key="item.idatividade">
                                                        <td class="small p-1">
                                                             <span class="font-weight-bold text-primary small">
                                                                {{ item.detalhes.nome }}
                                                            </span>
                                                            <br>
                                                            <span class="text-secondary small">
                                                                {{ dateFormat(item.data_gravacao) }}
                                                            </span>
                                                        </td>
                                                        <td class="small p-1">
                                                            {{ item.idatividade }}
                                                            <br>
                                                            <span class="font-weight-bold text-primary small">
                                                                {{ item.usuario_atividade }}
                                                            </span>
                                                        </td>
                                                        <td class="p-1">
                                                            <em class="fa fa-align-justify mt-3"
                                                            @click="getAtividade(item)"></em>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    
                </fieldset>
            </div>
        </div>

        <LogoutModal />
        <FooterBar />

        <Modal
            id="modalAtividade"
            :title="'Atividade Nº ' + this.atividadeModaId"
            :confirmFunction="() => atribuirAtividade()"
            :cancelFunction="() => closeModal('modalAtividade')"
            confirmText="Inciar"
            cancelText="Fechar"
        >
            <div class="text-left small">
                
                <span class="bg-danger p-1 m-0 rounded-top text-white">Tipo atividade</span>
                <br>
                <span class="font-weight-bold p-1 m-0 bg-secondary text-white rounded-right" id="tipoAtividadeModal">Aguarde...</span>
                <div class="mt-2 mb-0">
                    <span class="bg-danger p-1 m-0 rounded-top text-white mt-2">Cliente</span>
                    <br>
                    <span class="font-weight-bold p-1 m-0 bg-secondary text-white rounded-right" id="clienteAtividadeModal">Aguarde...</span>
                </div>
                <div class="mt-2 mb-0">
                    <span class="bg-danger p-1 m-0 rounded-top text-white">Produto</span>
                    <br>
                    <div class="p-2 m-0 border rounded-right small mb-2">
                        <span class="small font-weight-bold" id="produtoAtividadeModal">Aguarde...</span>
                        <br>
                        <span class="font-weight-bold">Cod. Barras: </span> <span class="small font-weight-bold" id="barrasAtividadeModal">Aguarde...</span>
                    </div>
                </div>
                <div class="mt-2 mb-0">
                    <span class="bg-danger p-1 m-0 rounded-top text-white">Usuário</span>
                    <br>
                    <span class="font-weight-bold p-1 m-0 bg-secondary text-white rounded-right" id="usuarioAtividadeModal">Aguarde...</span>
                </div>
                <hr>
                <span class="font-weight-bold" id="dataAtividadeModal">Aguarde...</span>
            </div>
        </Modal>

        <Modal
            id="modalAtribuirAtividade"
            title="Confirme:"
            :confirmFunction="() => atribuirAtividadeAMim()"
            :cancelFunction="() => closeModal('modalAtribuirAtividade')"
            confirmText="Sim"
            cancelText="Não"
        >
            <div class="text-left small">
                <h6>Atribuir esta atividade a mim?</h6>
            </div>
        </Modal>
    </div>
</template>
  
  
  <script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import Modal from "../components/Modal.vue";
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUserId, getUsername, getPerfil  } from '../services/api'
    import InputDefaultApp from "../components/InputDefaultApp.vue";
    import { dateFormat } from "../utils";
    import $ from "jquery";

  export default {
    name: 'Atividades',
    mixins: [
      ViewMixin,
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      InputDefaultApp,
      Modal,
    },
  
    data: () => {
      return {
        atividades : [],
        minhasatividades: [],
        categoriaId: null,
        atividadeModal: null,
        atividadeModaId: null,
        displayError: null,
        activeTab: 'tab1',
      };
    },
  
    async mounted() {
      try {
        await this.validarToken();
        await this.getAtividades();

        let x = this;

        setTimeout(() => {
            let searchInput = document.getElementById("searchInput");
            searchInput.addEventListener('keyup', () => {
                if (searchInput.value == "") {
                    x.atividades = [];
                    x.minhasatividades = [];
                    x.getAtividades();
                }
            });
        }, 250);
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
        getUsername,
        getPerfil,
        getUserId,

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        onModalClosed() {
            //
        },

        async getAtividades() {
            try {
                this.carregando = true;

                let result = await api.get("/atividades/listar");
                this.atividades = result.data.atividades;

                for (const item of this.atividades) {
                    if (item.idusuario_atv == getUserId()) {
                        this.minhasatividades.push(item);
                    }
                }
                this.carregando = false;
            } catch (error) {
                console.log(error);
                this.displayError = error;
            }
        },

        searchAtividade(id) {
            for (const item of this.atividades) {
                if (item.idatividade == id) {
                    this.atividades = [];
                    this.atividades.push(item);
                    break;
                }
            }
        },

        async getAtividade(atividade) {
            this.atividadeModal = atividade;
            console.log(this.atividadeModal);
            this.showModalAtividade();
        },

        showModalAtividade() {
            this.atividadeModaId = this.atividadeModal.idatividade;

            $("#modalAtividade").modal("show");
            document.getElementById("tipoAtividadeModal").innerText = this.atividadeModal.detalhes.nome;
            document.getElementById("clienteAtividadeModal").innerText = this.atividadeModal.cliente ? this.atividadeModal.cliente : "NÃO INFORMADO";
            document.getElementById("produtoAtividadeModal").innerText = this.atividadeModal.produto ? this.atividadeModal.produto : "NÃO INFORMADO";
            document.getElementById("barrasAtividadeModal").innerText = this.atividadeModal.codbarras ? this.atividadeModal.codbarras : "NÃO INFORMADO";
            document.getElementById("dataAtividadeModal").innerText = dateFormat(this.atividadeModal.data_gravacao);
            document.getElementById("usuarioAtividadeModal").innerText = this.atividadeModal.usuario_atividade ? this.atividadeModal.usuario_atividade : "NÃO ATRIBUÍDO";
        },

        atribuirAtividade() {

            $("#modalAtividade").modal("hide");
            let tipo = document.getElementById("tipoAtividadeModal").innerText;
            switch(tipo) {

                case "RESSUPRIMENTO_PULMAO":
                    tipo = "ressuprimentopulmao";
                    break;
                    
                case "MOVIMENTACAO_SHELF_LIFE":
                    tipo = "movimentacaoshelflife";
                    break;

                case "CONTAGEM_ESTOQUE":
                    tipo = "CONTAGEM_ESTOQUE";
                    break;

                default:
                    console.log("tipo de atividade inválida!");
                    break;
            }

            if (!this.atividadeModal.usuario_atividade) {
                $("#modalAtribuirAtividade").modal("show");
            } else if(this.atividadeModal.usuario_atividade != getUsername()) {
                $("#modalAtribuirAtividade").modal("show");
            } else {
                this.iniciarAtividade(tipo);
            }
        },

        async atribuirAtividadeAMim() {
            $("#modalAtribuirAtividade").modal("hide");
            this.carregando = true;

            try {
                let response = await api.post("/atividades/atribuir", {
                    "idusuario": getUserId(),
                    "idatividade": this.atividadeModal.idatividade
                });

                let tipo = document.getElementById("tipoAtividadeModal").innerText;
                switch(tipo) {

                    case "RESSUPRIMENTO_PULMAO":
                        tipo = "ressuprimentopulmao";
                        break;
                        
                    case "MOVIMENTACAO_SHELF_LIFE":
                        tipo = "movimentacaoshelflife";
                        break;

                    default:
                        console.log("tipo de atividade inválida!");
                        break;
                }

                if (response.data.status == "Success") {
                    this.$router.push(`/atividade/${tipo}/${this.atividadeModal.idatividade}`);
                }
            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },

        iniciarAtividade(tipo) {
            $("#modalAtribuirAtividade").modal("hide");
            this.$router.push(`/atividade/${tipo}/${this.atividadeModal.idatividade}`);
        },
    }
  }
  </script>
  
  <style scoped lang="scss">    
    .scroll-view {
        height: 220px;
        overflow-y: auto;
        overflow-x: hidden;
    }
  </style>
  